import React from "react";
import { LocaleProvider } from "./context/LocaleContext";
import Routes from "./Routes";

function App() {
  return (
    <LocaleProvider>
      <Routes />
    </LocaleProvider>
  );
}

export default App;